import { render, staticRenderFns } from "./prementoverview.vue?vue&type=template&id=74eb1e24&scoped=true&"
import script from "./prementoverview.vue?vue&type=script&lang=js&"
export * from "./prementoverview.vue?vue&type=script&lang=js&"
import style0 from "./prementoverview.vue?vue&type=style&index=0&id=74eb1e24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eb1e24",
  null
  
)

export default component.exports